import React from "react";
import { SessionAuth } from "supertokens-auth-react/recipe/session";
import { EmailVerificationClaim } from "supertokens-auth-react/recipe/emailverification";

const CustomSessionAuth = ({ children }) => {
    return (
        <SessionAuth
            overrideGlobalClaimValidators={(globalValidators) => [
                ...globalValidators,
                EmailVerificationClaim.validators.isVerified()
            ]}
        >
            {children}
        </SessionAuth>
    );
};

export default CustomSessionAuth;
